import { render, staticRenderFns } from "./ReviewCurriculumUnitList.vue?vue&type=template&id=56db828f&scoped=true&lang=pug&"
import script from "./ReviewCurriculumUnitList.vue?vue&type=script&lang=ts&"
export * from "./ReviewCurriculumUnitList.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewCurriculumUnitList.vue?vue&type=style&index=0&id=56db828f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56db828f",
  null
  
)

export default component.exports